import { FC, useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { RoutedStepsOrchestrator } from '@savgroup-front-common/core/molecules/RoutedStepsOrchestrator/RoutedStepsOrchestrator';
import { OnSubmit } from '@savgroup-front-common/core/molecules/RoutedStepsOrchestrator/RoutedStepsOrchestrator.types';

import { buildFileFollowupUrl } from '../../app/NewLayout/ClassiqueLayout.helpers';
import { InitContext } from '../../app/NewLayout/InitProvider/InitProvider.context';

import { useGetStepsConfig } from './IrshPages.config';
import { IrshStepValues } from './IrshPages.types';

export const IrshPages: FC = () => {
  const navigate = useNavigate();
  const { orders } = useContext(InitContext);
  const order = orders?.at(0);

  const handleOnSubmit: OnSubmit<IrshStepValues> = useCallback(
    ({ values }) => {
      if (!values.fileId) {
        throw new Error('File id is required');
      }

      const fileFollowupUrl = buildFileFollowupUrl({
        fileId: values.fileId,
      });

      navigate(fileFollowupUrl);
    },
    [navigate],
  );
  const config = useGetStepsConfig();

  return (
    <RoutedStepsOrchestrator
      config={config}
      onSubmit={handleOnSubmit}
      initialValues={{
        order: order,
      }}
    />
  );
};
